import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useSignal } from "@preact/signals";
import classNames from "classnames";
import TrafficLightBar from "../TrafficLightBar";
import SummaryMetric from "../SummaryMetric";
import style from "./style.module.scss";
export default function ThreeMetricTrafficLight(props) {
    const { goodLabel, goodValue, goodChangeValue, warningLabel, warningValue, warningChangeValue, badLabel, badValue, badChangeValue, changeSuffix = "", valueSuffix = "", animated = false, } = props;
    const highlightedSegment = useSignal(props.highlightedSegment);
    useEffect(() => {
        // Allow parent components to manage the highlighted segment by updating the local state
        // whenever the prop changes
        highlightedSegment.value = props.highlightedSegment;
    }, [props.highlightedSegment, highlightedSegment]);
    const trafficLightSegments = [];
    //Add the Good metric.
    const goodSegment = {
        id: goodLabel,
        value: goodValue,
        color: "var(--good-color)",
    };
    //Add the Warning metric.
    const warningSegment = {
        id: warningLabel,
        value: warningValue,
        color: "var(--warning-color)",
    };
    //Add the Bad metric.
    const badSegment = {
        id: badLabel,
        value: badValue,
        color: "var(--bad-color)",
    };
    trafficLightSegments.push(goodSegment);
    trafficLightSegments.push(warningSegment);
    trafficLightSegments.push(badSegment);
    //User has hovered over a segment.
    function onSegmentOver(event, label) {
        if (props.onSegmentOver) {
            props.onSegmentOver(event, label);
        }
        highlightedSegment.value = label;
    }
    //User moved off a segment.
    function onSegmentOut(event) {
        if (props.onSegmentOut) {
            props.onSegmentOut(event);
        }
        highlightedSegment.value = undefined;
    }
    //User clicked on a segment.
    function onSegmentClick(event, label) {
        if (props.onSegmentClick) {
            props.onSegmentClick(event, label);
        }
    }
    //Check if the highlight segment is active, make sure we dim any of the summary metrics that should not be highlighted.
    let goodClass = style["good-metric"];
    let warningClass = style["warning-metric"];
    let badClass = style["bad-metric"];
    if (highlightedSegment.value) {
        switch (highlightedSegment.value) {
            case goodLabel:
                warningClass = style["warning-metric--dim"];
                badClass = style["bad-metric--dim"];
                break;
            case warningLabel:
                goodClass = style["good-metric--dim"];
                badClass = style["bad-metric--dim"];
                break;
            case badLabel:
                goodClass = style["good-metric--dim"];
                warningClass = style["warning-metric--dim"];
                break;
            default:
                break;
        }
    }
    return (_jsxs("div", { className: classNames(style["three-metric-traffic-light"], "qa-three-metric-traffic-light"), children: [_jsx("div", { className: style["traffic-light-bar"], children: _jsx(TrafficLightBar, { trafficLightSegments: trafficLightSegments, onSegmentOver: onSegmentOver, onSegmentOut: onSegmentOut, onSegmentClick: onSegmentClick, highlightedSegment: highlightedSegment.value }) }), _jsxs("div", { className: style["three-metric-traffic-light__summary-block"], children: [_jsx(SummaryMetric, { label: goodLabel, value: goodValue, suffix: valueSuffix, className: goodClass, changeValue: goodChangeValue, changeSuffix: changeSuffix, animated: animated, onOver: onSegmentOver, onOut: onSegmentOut, onClick: onSegmentClick }, "good-metric"), _jsx(SummaryMetric, { label: warningLabel, value: warningValue, suffix: valueSuffix, className: warningClass, changeValue: warningChangeValue, changeSuffix: changeSuffix, animated: animated, onOver: onSegmentOver, onOut: onSegmentOut, onClick: onSegmentClick }, "warning-metric"), _jsx(SummaryMetric, { label: badLabel, value: badValue, suffix: valueSuffix, className: badClass, changeValue: badChangeValue, changeSuffix: changeSuffix, animated: animated, onOver: onSegmentOver, onOut: onSegmentOut, onClick: onSegmentClick }, "bad-metric")] })] }));
}
